import { render, staticRenderFns } from "./classDropdown.vue?vue&type=template&id=71bba56a&scoped=true"
import script from "./classDropdown.vue?vue&type=script&lang=js"
export * from "./classDropdown.vue?vue&type=script&lang=js"
import style0 from "./classDropdown.vue?vue&type=style&index=0&id=71bba56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bba56a",
  null
  
)

export default component.exports